import Gradient from 'javascript-color-gradient'

export const createGradient = (colors: string[], steps: number) => {
  return new Gradient().setColorGradient(...colors).setMidpoint(steps)
}
